module.exports = __webpack_public_path__ + "img/p-three-step-05.285f090e.png";